export enum InternalUserPermission {
    // ── Subscription ─────────────────────────────────────────────
    VIEW_SUBSCRIPTION_DETAILS = 'view_subscription_details',
    VIEW_COST_PER_MESSAGE = 'view_cost_per_message',
    VIEW_SUBSCRIPTION_PRICE = 'view_subscription_price',
    DEACTIVATE_SUBSCRIPTION = 'deactivate_subscription',
    NEW_SUBSCRIPTION = 'new_subscription',
    VIEW_ONE_TIME_CHARGES = 'view_one_time_charges',
    STOP_PACKAGES = 'stop_packages',
    CREATE_PACKAGES = 'create_packages',
    TEST_SUBSCRIPTION = 'test-subscription',

    // ── Billing ───────────────────────────────────────────────────
    VIEW_BILLING_INVOICE_PRICES = 'view_billing_invoice_prices',
    VIEW_BILLING_ENTITIES = 'view_billing_entities',
    MARK_PACKAGES_PAID = 'mark_packages_paid',

    // ── Invoices ──────────────────────────────────────────────────
    VIEW_INVOICES = 'view-invoices',

    // ── Notes ─────────────────────────────────────────────────────
    VIEW_CS_NOTES = 'view_cs_notes',
    EDIT_CS_NOTES = 'edit_cs_notes',
    VIEW_DEV_NOTES = 'view_dev_notes',
    EDIT_DEV_NOTES = 'edit_dev_notes',
    VIEW_SALES_NOTES = 'view_sales_notes',
    EDIT_SALES_NOTES = 'edit_sales_notes',

    // ── Management ────────────────────────────────────────────────
    CREATE_TENANT = 'create_tenant',
    CREATE_NEW_BUSINESS = 'create_new_business',

    // ── Tenant listing ────────────────────────────────────────────
    MANAGE_TENANT_TAGS = 'manage_tenant_tags',
    BULK_EDIT_TENANTS = 'bulk_edit_tenants',
}
